/* eslint-disable react-hooks/exhaustive-deps */
import { Affix, Button, Checkbox, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
// import { PlusCircleOutlined } from '@ant-design/icons';
import RopaService from '../../../../services/Ropa.service';
import { useBlocker } from '../../../../util/usePrompt';
import useNotify from '../../../../context/Notification/useNotify';
import { useNavigate, useParams } from 'react-router-dom';
import ModalDiscardChanges from '../../../../components/Shared/modal/discardChanges';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import { ROUTER } from '../../../../constants/router';

const Tab2 = ({ categoryPersonalData, getRopaDetail }) => {
    const { t, i18n } = useTranslation();
    let { activityId } = useParams();
    const [form] = Form.useForm();
    const [personalDataOptionSelect, setPersonalDataOption] = useState([]);
    const [sensitivePersonalDataOptionSelect, setSensitivePersonalDataOption] =
        useState([]);
    const [personalDataTopicSelect, setPersonalDataTopicOption] = useState([]);
    const lang = i18n.language;

    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [valueSave, setValueSave] = useState();
    const [loading, setLoading] = useState(false);

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    const Navigate = useNavigate();
    const notify = useNotify();

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await getRopaDetail();
        await Navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    useEffect(() => {
        const getPersonalData = async () => {
            const { data } = await RopaService.getPersonalData(activityId);
            if (data.resultData) {
                setPersonalDataOption(data.resultData);
            }
        };
        const getSensitiveData = async () => {
            const { data } = await RopaService.getSensitiveData(activityId);
            if (data?.resultData) {
                if (data?.resultData[0] !== null) {
                    setSensitivePersonalDataOption(data?.resultData);
                }
            }
        };
        const getPersonalDataTopic = async () => {
            const { data } = await RopaService.getPersonalDataTopic(activityId);
            if (data.resultData) {
                setPersonalDataTopicOption(data.resultData);
            }
        };
        getPersonalData();
        getSensitiveData();
        getPersonalDataTopic();
    }, []);

    const onSubmit = async () => {
        const topicOption = [];
        for (const item in personalDataTopicSelect) {
            if (personalDataTopicSelect[item].personalDataTopicId) {
                let optionItem = [];
                for (const i in personalDataTopicSelect[item]
                    .personalDataTopicOption) {
                    if (
                        valueSave.personalDataTopic.includes(
                            personalDataTopicSelect[item]
                                .personalDataTopicOption[i]
                                .personalDataTopicOptionId
                        )
                    ) {
                        optionItem.push(
                            personalDataTopicSelect[item]
                                .personalDataTopicOption[i]
                                .personalDataTopicOptionId
                        );
                    }
                }
                topicOption.push({
                    personalDataTopicId:
                        personalDataTopicSelect[item].personalDataTopicId,
                    personalDataTopicOption: optionItem,
                });
            }
        }
        const payload = {
            activityId: activityId,
            categoryPersonalData: {
                personalData: valueSave.personalData
                    ? valueSave.personalData
                    : [],
                sensitiveData: valueSave.sensitiveData
                    ? valueSave.sensitiveData
                    : [],
                personalDataTopic: topicOption
                    ? topicOption.filter(
                          (e) => e.personalDataTopicOption.length
                      )
                    : [],
            },
        };
        try {
            const { data } = await RopaService.updateCategoryPersonalData(
                payload
            );
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to submitted'),
                });
                setOpenChange(false);
                setChange(false);
                setLoading(false);
                setOpenConfirm(false);
                Navigate(
                    `${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view?tab=2`
                );
            } else {
                setOpenConfirm(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        } catch (error) {
            console.log(error);
            setOpenConfirm(false);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
        }
    };

    useEffect(() => {
        if (change === 3) {
            changePage();
        }
    }, [change]);

    const changePage = () => {
        Navigate(`${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view?tab=2`);
    };

    useEffect(() => {
        if (categoryPersonalData) {
            const option = [];
            for (const item in categoryPersonalData?.personalDataTopic) {
                for (const i in categoryPersonalData?.personalDataTopic[item]
                    .personalDataTopicOption) {
                    option.push(
                        categoryPersonalData?.personalDataTopic[item]
                            .personalDataTopicOption[i]
                            .personalDataTopicOptionId
                    );
                    form.setFieldsValue({
                        personalDataTopic: option,
                    });
                }
            }
            form.setFieldsValue({
                personalData: categoryPersonalData?.personalData?.map(
                    (e) => e.id
                ),
                sensitiveData: categoryPersonalData?.sensitiveData?.map(
                    (e) => e.id
                ),
                allData:
                    categoryPersonalData?.personalData ||
                    categoryPersonalData?.sensitiveData
                        ? '1'
                        : '',
            });
        }
    }, [categoryPersonalData]);

    return (
        <>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                layout="vertical"
                form={form}
                onFinish={(value) => {
                    setOpenConfirm(true);
                    setValueSave(value);
                }}
                onFieldsChange={(_, allFields) => {
                    if (allFields.length > 0) {
                        setChange(true);
                    }
                }}
                onValuesChange={(_, allValues) => {
                    if (
                        allValues.personalData?.length > 0 ||
                        allValues.sensitiveData?.length > 0 ||
                        allValues.personalDataTopic?.length > 0
                    ) {
                        form.setFieldsValue({
                            allData: '1',
                        });
                    } else {
                        form.setFieldsValue({
                            allData: '',
                        });
                    }
                }}
            >
                <Affix offsetTop={60}>
                    <div className="flex justify-end space-x-3">
                        <Button
                            size="large"
                            type="default"
                            className="text-purple-PHX border-purple-PHX w-32"
                            onClick={changePage}
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            size="large"
                            type="primary"
                            className="w-32"
                            htmlType="submit"
                        >
                            {t('common.Save')}
                        </Button>
                    </div>
                </Affix>
                <Form.Item
                    className="mt-2"
                    name={'personalData'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.TypePersonalData')}
                        </span>
                    }
                >
                    <Checkbox.Group
                        className="w-full"
                        hidden={!personalDataOptionSelect.length}
                    >
                        <div
                            style={{ background: '#F4F6FC' }}
                            className="p-4 rounded-md mt-4"
                        >
                            <div className="text-sm font-semibold">
                                {t('policy.personalDataOption')}
                            </div>
                            {personalDataOptionSelect.map((is) => {
                                return (
                                    <div key={is.id}>
                                        <Checkbox
                                            key={is.id}
                                            value={is.id}
                                            style={{
                                                lineHeight: '32px',
                                            }}
                                        >
                                            {lang === 'en' ? is.name : is.name}
                                        </Checkbox>
                                        <br />
                                    </div>
                                );
                            })}
                        </div>
                    </Checkbox.Group>
                </Form.Item>
                <Form.Item
                    className="mt-2"
                    name={'sensitiveData'}
                    hidden={!sensitivePersonalDataOptionSelect.length}
                >
                    <Checkbox.Group className="w-full">
                        <div
                            style={{ background: '#F4F6FC' }}
                            className="p-4 rounded-md"
                        >
                            <div className="text-sm font-semibold">
                                {t('policy.sensitivePersonalDataOption')}
                            </div>
                            {sensitivePersonalDataOptionSelect.map((is) => {
                                return (
                                    <div key={is.id}>
                                        <Checkbox
                                            key={is.id}
                                            value={is.id}
                                            style={{
                                                lineHeight: '32px',
                                            }}
                                        >
                                            {lang === 'en' ? is.name : is.name}
                                        </Checkbox>
                                        <br />
                                    </div>
                                );
                            })}
                        </div>
                    </Checkbox.Group>
                </Form.Item>

                <Form.Item className="mt-2" name={'personalDataTopic'}>
                    <Checkbox.Group className="w-full ">
                        {personalDataTopicSelect.map((is, i) => {
                            return (
                                <>
                                    <div
                                        style={{ background: '#F4F6FC' }}
                                        className="p-4 rounded-md mb-6"
                                    >
                                        <div className="text-sm font-semibold">
                                            {is.personalDataTopicName}
                                            {/* {t(
                                                'policy.sensitivePersonalDataOption'
                                            )} */}
                                        </div>
                                        {is.personalDataTopicOption.map(
                                            (item) => {
                                                return (
                                                    <div
                                                        key={
                                                            is.personalDataTopicId +
                                                            '_' +
                                                            item.personalDataTopicOptionId
                                                        }
                                                    >
                                                        <Checkbox
                                                            key={
                                                                is.personalDataTopicId +
                                                                '_' +
                                                                item.personalDataTopicOptionId
                                                            }
                                                            value={
                                                                item.personalDataTopicOptionId
                                                            }
                                                            style={{
                                                                lineHeight:
                                                                    '32px',
                                                            }}
                                                        >
                                                            {lang === 'en'
                                                                ? item.personalDataTopicOptionName
                                                                : item.personalDataTopicOptionName}
                                                        </Checkbox>
                                                        <br />
                                                    </div>
                                                );
                                            }
                                        )}
                                    </div>
                                </>
                            );
                        })}
                    </Checkbox.Group>
                </Form.Item>
                <Form.Item
                    style={{
                        marginTop: `${
                            sensitivePersonalDataOptionSelect?.length > 0
                                ? '-8%'
                                : '-10%'
                        }`,
                        zIndex: '-3',
                    }}
                    name={'allData'}
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                ></Form.Item>
            </Form>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onSubmit}
                handelClose={() => setOpenConfirm(false)}
            />
        </>
    );
};

export default Tab2;
